import axios from "axios";
import { getAPIUrl } from "../config";

const api = axios.create({
  baseURL: getAPIUrl(),
});

const userService = {
  async getUsers(page, size, { name, genders, roles } = {}) {
    const token = localStorage.getItem("token");

    try {
      const params = { page, size };

      if (name) {
        params.name = name;
      }

      if (genders?.length) {
        params.genders = genders;
      }

      if (roles?.length) {
        params.roles = roles;
      }

      const response = await api.get("/v1/users", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
        paramsSerializer: {
          indexes: null,
        },
      });

      return response.data;
    } catch (error) {
      throw new Error("Erro ao buscar usuários");
    }
  },
  async getUserById(id) {
    const token = localStorage.getItem("token");

    try {
      const response = await api.get(`/v1/users/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      throw new Error("Erro ao buscar usuários");
    }
  },

  async getMealSummary(userId, date) {
    const token = localStorage.getItem("token");

    try {
      const response = await api.get(`/v1/users/${userId}/meals?date=${date}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      throw new Error("Erro ao buscar resumo de refeições");
    }
  },

  async getMonthlyMealSummary(userId, yearMonth) {
    const token = localStorage.getItem("token");

    try {
      const response = await api.get(`/v1/users/${userId}/meal-reports?year_month=${yearMonth}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      throw new Error("Erro ao buscar resumo de refeições mensal");
    }
  },

  async updatePhoto(userId, photoId) {
    const token = localStorage.getItem("token");

    const response = await api.put(`/v1/users/${userId}/photos/${photoId}`, {}, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  },

  async getUserStreak(userId) {
    const token = localStorage.getItem("token");

    try {
      const response = await api.get(`/v1/users/${userId}/streak`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      throw new Error("Erro ao buscar streak do usuário");
    }
  },

  async getUserMealsHistory(userId, page, size, { from, to } = {}) {
    const token = localStorage.getItem("token");

    try {
      const params = { page, size };
      if (from) {
        params.from = from;
      }
      if (to) {
        params.to = to;
      }

      const response = await api.get(`/v1/users/${userId}/meals/history`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      });

      return response.data;
    } catch (error) {
      throw new Error("Erro ao buscar histórico de refeições");
    }
  },

  async getUserMealsHistorySummary(userId) {
    const token = localStorage.getItem("token");

    try {
      const response = await api.get(`/v1/users/${userId}/meals/history/summary`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      throw new Error("Erro ao buscar resumo de refeições");
    }
  },
};

export default userService;
